import { Swiper } from 'swiper/react';
import { EffectCreative } from 'swiper/modules';
import { FC, PropsWithChildren } from 'react';
import { useScopedAtomValue, useSetScopedAtom } from '@lemon8/webapp-shared/component';
import { $MainSwiper, $RootPaddingBottom } from '../../atoms';

import './style.scss';

export const MainSwiper: FC<PropsWithChildren> = ({ children }) => {
  const setMainSwiper = useSetScopedAtom($MainSwiper);
  const paddingBottom = useScopedAtomValue($RootPaddingBottom);

  return (
    <Swiper
      className="gallery-main-swiper"
      style={{ paddingBottom: `${paddingBottom}%` }}
      effect="creative"
      resistanceRatio={0}
      onSwiper={setMainSwiper}
      creativeEffect={{
        prev: {
          translate: [0, 0, -10],
        },
        next: {
          opacity: 0.5,
          translate: ['100%', 0, 0],
        },
      }}
      modules={[EffectCreative]}
    >
      {children}
    </Swiper>
  );
};
